// Centralized environment access. Components/hooks MUST import from here
// instead of touching `import.meta.env` directly (see CLAUDE-react.md → Environment Variables).
export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL as string,
  appName: (import.meta.env.VITE_APP_NAME as string | undefined) ?? 'ДАТА 1861',
  isDev: import.meta.env.DEV,
  // Matrix homeserver (чат). Абсолютный URL — SPA ходит на homeserver НАПРЯМУЮ (свой хост, открытый CORS),
  // не через /api-прокси. Логин в Matrix — существующим Keycloak-токеном app (com.graintrade.login.jwt).
  // `||` (не `??`): пустая строка из .env должна откатываться к дефолту (иначе fetch уйдёт на origin app).
  matrixServerUrl:
    (import.meta.env.VITE_MATRIX_SERVER_URL as string | undefined) || 'https://matrix-dev.data1861.ru',
} as const;
